// extracted by mini-css-extract-plugin
export var borderRadius = "_ag-4";
export var large = "_ag-3";
export var logoContainer = "_ag-0";
export var nameLogo = "_ag-2";
export var small = "_ag-1";